// Generated by CoffeeScript 1.12.5
var isNumber;

import toString from 'es-tostring';

export default isNumber = function(value) {
  return toString(value) === '[object Number]';
};

//# sourceMappingURL=number.js.map
